var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 33,
    viewBox: "0 0 16 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M14.712 10.432L12.562.767V.718c0-.397-.374-.718-.839-.718-.463 0-.84.321-.84.718v30.355c0 .396.377.718.84.718.465 0 .84-.322.84-.718v-15.75l2.076-4.448c.094-.134.12-.293.073-.443M7.38 0h-.327c-.231 0-.42.16-.42.36v6.882h-2.15V.36C4.483.16 4.295 0 4.063 0h-.326c-.232 0-.42.16-.42.36v6.882h-2.15V.36C1.166.16.977 0 .746 0H.418C.19 0 0 .16 0 .36v6.882c0 1.594 1.31 2.925 3.06 3.255v20.576c0 .396.376.718.84.718.463 0 .84-.322.84-.718V10.497c1.749-.33 3.06-1.66 3.06-3.255V.36C7.8.16 7.611 0 7.38 0",
    transform: "translate(.12 .62)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69B045",
    d: "M10.884 20.486v10.587c0 .397.376.718.84.718.463 0 .84-.321.84-.718V20.486h-1.68zM3.06 20.486v10.587c0 .397.376.718.84.718.463 0 .84-.321.84-.718V20.486H3.06z",
    transform: "translate(.12 .62)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.4cf96ac87309ee5167e6d8a322aec1c4.svg";
export { ForwardRef as ReactComponent };